// FETCH ALL DYEING INWARD
export const FETCH_DYEING_INWARD_MASTER_REQUEST = 'FETCH_DYEING_INWARD_MASTER_REQUEST';
export const FETCH_DYEING_INWARD_MASTER_SUCCESS = 'FETCH_DYEING_INWARD_MASTER_SUCCESS';
export const FETCH_DYEING_INWARD_MASTER_FAILURE = 'FETCH_DYEING_INWARD_MASTER_FAILURE';

// CREATE DYEING INWARD
export const CREATE_DYEING_INWARD_MASTER_REQUEST = 'CREATE_DYEING_INWARD_MASTER_REQUEST';
export const CREATE_DYEING_INWARD_MASTER_SUCCESS = 'CREATE_DYEING_INWARD_MASTER_SUCCESS';
export const CREATE_DYEING_INWARD_MASTER_FAILURE = 'CREATE_DYEING_INWARD_MASTER_FAILURE';

// UPDATE DYEING INWARD
export const UPDATE_DYEING_INWARD_MASTER_REQUEST = 'UPDATE_DYEING_INWARD_MASTER_REQUEST';
export const UPDATE_DYEING_INWARD_MASTER_SUCCESS = 'UPDATE_DYEING_INWARD_MASTER_SUCCESS';
export const UPDATE_DYEING_INWARD_MASTER_FAILURE = 'UPDATE_DYEING_INWARD_MASTER_FAILURE';

// FETCH SINGLE STATE OF DYEING INWARD
export const FETCH_SINGLE_DYEING_INWARD_MASTER_REQUEST = 'FETCH_SINGLE_DYEING_INWARD_MASTER_REQUEST';
export const FETCH_SINGLE_DYEING_INWARD_MASTER_SUCCESS = 'FETCH_SINGLE_DYEING_INWARD_MASTER_SUCCESS';
export const FETCH_SINGLE_DYEING_INWARD_MASTER_FAILURE = 'FETCH_SINGLE_DYEING_INWARD_MASTER_FAILURE';

// DELETE DYEING INWARD
export const DELETE_DYEING_INWARD_MASTER_REQUEST = 'DELETE_DYEING_INWARD_MASTER_REQUEST';
export const DELETE_DYEING_INWARD_MASTER_SUCCESS = 'DELETE_DYEING_INWARD_MASTER_SUCCESS';
export const DELETE_DYEING_INWARD_MASTER_FAILURE = 'DELETE_DYEING_INWARD_MASTER_FAILURE';

export const FETCH_PENDING_DYEING_PO_IN_INWARD_REQUEST = 'FETCH_PENDING_DYEING_PO_IN_INWARD_REQUEST';
export const FETCH_PENDING_DYEING_PO_IN_INWARD_SUCCESS = 'FETCH_PENDING_DYEING_PO_IN_INWARD_SUCCESS';
export const FETCH_PENDING_DYEING_PO_IN_INWARD_FAILURE = 'FETCH_PENDING_DYEING_PO_IN_INWARD_FAILURE';

export const RESET_DYEING_INWARD_MASTER_INFO = 'RESET_DYEING_INWARD_MASTER_INFO';

export const CREATE_DYEING_INWARD_MASTER_FORM = 'CREATE_DYEING_INWARD_MASTER_FORM';

export const UPDATE_DYEING_INWARD_MASTER_FORM = 'UPDATE_DYEING_INWARD_MASTER_FORM';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_DYEING_INWARD_DETAILS = 'NAVIGATE_DYEING_INWARD_DETAILS';

// NAVIGATE TO DYEING INWARD COMPONENT
export const NAVIGATE_DYEING_INWARD_MASTER = 'NAVIGATE_DYEING_INWARD_MASTER';

export const RESET_FORM_DATA_WITHOUT_DYEING_INWARD_ID = 'RESET_FORM_DATA_WITHOUT_DYEING_INWARD_ID';

export const SET_ACTIVE_KEY_DYEING_INWARD = 'SET_ACTIVE_KEY_DYEING_INWARD';

export const SET_UNIT_NAME_DYEING_INWARD = 'SET_UNIT_NAME_DYEING_INWARD';
export const SET_START_DATE_DYEING_INWARD = 'SET_START_DATE_DYEING_INWARD';
export const SET_END_DATE_DYEING_INWARD = 'SET_END_DATE_DYEING_INWARD';
